import Api from './Api'
import config from '@/config'

export default {
    getSites(obj) {
        return Api().post('sites', obj)
    },
    // link editable from the balkan-app admin panel, falls back to the hardcoded one in config.js
    async getLink(key) {
        const { data } = await Api().get('agentLinks').catch(() => ({}))
        return data?.[key] || config[key]
    }
}
